import { useNavigate } from 'react-router-dom';

/**
 * Botão flutuante de "voltar" fixado próximo ao rodapé — acompanha a rolagem da
 * página, para o usuário poder retornar à tela anterior a qualquer momento.
 */
export function FloatingBack({ to, label = 'Voltar' }: { to: string; label?: string }) {
  const nav = useNavigate();
  return (
    <button className="floating-back" onClick={() => nav(to)} aria-label={label}>
      <span aria-hidden="true">←</span> {label}
    </button>
  );
}
